import { Component, Input, OnChanges } from '@angular/core';
import { CommonModule } from '@angular/common';
import { getTheme } from '../../themes/theme.config';

@Component({
  selector: 'crowdctrl-theme-preview-item',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './theme-preview-item.component.html',
  styleUrl: './theme-preview-item.component.css',
})
export class ThemePreviewItemComponent implements OnChanges {
  @Input() themeName: string | null = null;
  @Input() showModeLabel = true;
  @Input() compact = false;

  displayName = 'Default';
  primary = '#000000';
  secondary = '#000000';
  hasPair = false;
  modeLabel: 'Dark Mode' | 'Light Mode' | null = null;

  ngOnChanges(): void {
    this.refreshPreview();
  }

  private refreshPreview(): void {
    if (!this.themeName) {
      this.displayName = 'Default';
      this.primary = '#000000';
      this.secondary = '#000000';
      this.hasPair = false;
      this.modeLabel = null;
      return;
    }

    const theme = getTheme(this.themeName);
    this.displayName = theme?.displayName || this.themeName;
    this.primary = theme?.colors.primary.value || '#000000';
    this.secondary = theme?.colors.secondary.value || '#000000';

    const baseName = this.themeName.replace(/-light$|-dark$/, '');
    this.hasPair = !!(getTheme(`${baseName}-light`) && getTheme(`${baseName}-dark`));
    this.modeLabel = this.hasPair ? (theme?.isDark ? 'Dark Mode' : 'Light Mode') : null;
  }
}
